import { IAdvantage } from '@/models/category.model';

export enum UpdateCategoryFieldNames {
  IMAGE = 'image',
  THUMBNAIL = 'thumbnail',
  VIDEO = 'video',
  ICON = 'icon',
  ADVANTAGES = 'advantages',
  TITLE = 'title',
  DESCRIPTION = 'description',
  SEO_BLOCK = 'seoBlocks',
  SEO_KEYWORDS = 'seoKeywords',
  SEO_DESCRIPTION = 'seoDescription',
  SEO_TITLE = 'seoTitle',
  ALT_ICON = 'altIcon',
  ALT_IMAGE = 'altImage',
  ALT_THUMBNAIL = 'altThumbnail',
}

export type TUpdateCategoryFormValues = {
  [UpdateCategoryFieldNames.IMAGE]?: Blob | string;
  [UpdateCategoryFieldNames.VIDEO]?: Blob | string;
  [UpdateCategoryFieldNames.ICON]?: Blob | string;
  [UpdateCategoryFieldNames.THUMBNAIL]?: Blob | string;
  [UpdateCategoryFieldNames.ADVANTAGES]?: IAdvantage[];
  [UpdateCategoryFieldNames.SEO_KEYWORDS]?: string[];
  [UpdateCategoryFieldNames.SEO_DESCRIPTION]?: string;
  [UpdateCategoryFieldNames.SEO_TITLE]?: string;
  [UpdateCategoryFieldNames.DESCRIPTION]?: string;
  [UpdateCategoryFieldNames.SEO_BLOCK]?: string[];
  [UpdateCategoryFieldNames.ALT_ICON]?: string;
  [UpdateCategoryFieldNames.ALT_IMAGE]?: string;
  [UpdateCategoryFieldNames.ALT_THUMBNAIL]?: string;
};
